
import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import WebsiteContentField from '../../components/WebsiteContentField';

export default class EditEventForm extends React.Component {

  requiredFields = ["title"]

  constructor(props) {
    super(props)
    this.state = {
      eventImage: null,
      eventName: '',
      eventUrl: '',
    }
    this.onSubmit = this.onSubmit.bind(this);
  }

  onFieldChange = (propertyName, value) => {
    let s = {
      ...this.state,
      [propertyName]: value
    };
    this.setState(s);
  }

  onSubmit() {
    this.props.onSubmit(this.state);
  }

  render() {

    const actions = [
      <FlatButton
        label="Cancel"
        primary={false}
        keyboardFocused={true}
        onTouchTap={this.props.onClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        keyboardFocused={true}
        onTouchTap={this.onSubmit}
      />,
    ];
    return (
      <Dialog
          title='Edit Event'
          actions={actions}
          modal={true}
          open={this.props.show}
          onRequestClose={this.onClose}
      >
          <WebsiteContentField label="Event Name" icon="link" value={this.state.eventName} onChange={(value)=> this.onFieldChange('eventName', value)} type="text" />
          <WebsiteContentField label="Event Image" icon="picture" value={this.state.eventImage} onChange={(value)=> this.onFieldChange('eventImage', value)} type="photo" finePrint="Recommended size: 1920px width, 600px height - File format: JPG" />
          <WebsiteContentField label="Event Link (ie. Facebook URL)" icon="link" value={this.state.eventLink} onChange={(value)=> this.onFieldChange('eventLink', value)} type="text" />
          <WebsiteContentField label="Event Description" icon="link" value={this.state.eventDescription} onChange={(value)=> this.onFieldChange('eventDescription', value)} type="richtext" />
          <WebsiteContentField label="Event Date" icon="calendar" value={this.state.eventDate} onChange={(value)=> this.onFieldChange('eventDate', value)} type="date" />
          <WebsiteContentField label="Event Time" icon="calendar" value={this.state.eventTime} onChange={(value)=> this.onFieldChange('eventTime', value)} type="time" />
          <WebsiteContentField label="Event Price" icon="quote" value={this.state.eventPrice} onChange={(value)=> this.onFieldChange('eventPrice', value)} type="text" />  
      </Dialog>
    );

  }


}



// WEBPACK FOOTER //
// ./src/containers/Website/EditEventForm.js